
      window.__ENV__ = {
        VITE_ENABLE_TRACKING: import.meta.env.VITE_ENABLE_TRACKING ?? '',
        VITE_ANALYTICS_HOST: import.meta.env.VITE_ANALYTICS_HOST ?? '',
      };
    